(function(){
  document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', function(e) {
      if ( e.target.matches('.variant_add_to_cart') || e.target.closest('.variant_add_to_cart')) {
        e.preventDefault();
        let checkbox = e.target.closest('.variant_wrapper')?.querySelector('label');
        checkbox?.click();
        setTimeout(function() {
          let addToCart = document.querySelector('product-info .product-form__submit');
          addToCart?.click();
        }, 1000);
      }
    });

    
    /**
    * code for position sticky header
    */
    function handleHeaderPosition() {
      let header = document.querySelector('.shopify-section-group-header-group.section-header');
      let announcementBarSection = document.querySelector('.announcement-bar-section');
      if ( ! header || ! announcementBarSection ) { 
        header.style.top = 0;
      } else {
        header.style.top = announcementBarSection.offsetHeight + 'px';
      }
      
    }
    handleHeaderPosition();
    
    var playButton = document.querySelectorAll('.banner_section .video-section__poster');
    if ( playButton ) {
      setTimeout(function() {
        playButton.forEach( elem => {
          elem.click();
          window.scrollBy(0,2);
        });
        document.addEventListener("scroll", (event) => {
          var videoelem = document.querySelectorAll('.banner_section video');
          videoelem.forEach( elem => {
            elem.play();
          });
        });
        document.addEventListener("touchstart", (event) => {
          var videoelem = document.querySelectorAll('.banner_section video');
          videoelem.forEach( elem => {
            elem.play();
          });
        });
      }, 100);
    }
    
    
    
     
    /*
    * start code for hover menu open
    */
    // const inlineMenu = document.querySelectorAll(".header__inline-menu");
    const detailsItems = document.querySelectorAll(".header__inline-menu details");
      detailsItems.forEach(item => {
        const ulElement = item.querySelector("ul");
        item.addEventListener("mouseover", () => {
          item.setAttribute("open", true);
          ulElement.addEventListener("mouseleave", () => {
            item.removeAttribute("open");
          });
          item.addEventListener("mouseleave", () => {
            item.removeAttribute("open");
          });
        });
      });
     /*
    * end start code for hover menu open
    */

    
    console.log('jsfile');
    window.initJsSlideProduct = () => {

      function isVideoPlay(that) {
        if ( document.querySelectorAll('.js-product-main-slider .swiper-slide-active .deferred-media__poster')?.length > 0 ) {
          document.querySelector('.js-product-main-slider .swiper-slide-active .deferred-media__poster').click();
          
          setTimeout(() => {
            // console.log("Delayed for 1 second.");
             if ( document.querySelector('.js-product-main-slider .swiper-slide-active video')?.length > 0 ) {
              let video = document.querySelector('.js-product-main-slider .swiper-slide-active video');
              try {
                video[0].play();
              } catch (error) {
                console.log(error);
              }
            }
          }, "1000");
        }
        if ( document.querySelectorAll('.js-product-main-slider .swiper-slide-active video')?.length > 0 ) {
          let video = document.querySelector('.js-product-main-slider .swiper-slide-active video');
          
          try {
            video[0].play();
          } catch (error) {
            console.log(error);
          }
        }
      }

      let containerProduct = document.querySelectorAll('product-info');
      containerProduct.forEach(elem => {
        let thumbItem = elem.querySelector('.js-product-thumbnail-slider');
        let sliderThumbnail = new Swiper(thumbItem, {
          direction: 'vertical', // Set direction to vertical
          spaceBetween: 11,
          autoHeight: true,
          mousewheel: true,
          slidesPerView: 5,
          freeMode: true,
          on:{
            slideChangeTransitionEnd:function(){
              isVideoPlay(this);
            }
          },
          breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: 4,
            },
            // when window width is >= 640px
            640: {
              slidesPerView: 5,
            }
          }
        });
    
        let mainItem = elem.querySelector('.js-product-main-slider');
        let galleryMain = new Swiper(mainItem, {
          // navigation: {
          //   nextEl: '.swiper-button-next',
          //   prevEl: '.swiper-button-prev',
          // },
          thumbs: {
            swiper: sliderThumbnail
          },
          // autoHeight: true,
          on:{
            slideChangeTransitionEnd:function(){
              isVideoPlay(this);
            }
          },
          breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: 1.3,
              centeredSlides: true,
              loop: true,
              // initialSlide: 1,
              spaceBetween: 15,
            },
            // when window width is >= 640px
            767: {
              slidesPerView: 1,
              
            }
          }
        });
      });
      
    }
    window.initJsSlideProduct();
 }, false);
})();
